<template lang="pug">
.file-version-list
    .base-item
        font-awesome-icon.icon-item(:icon="getIconType(getBaseItem)[0]" :class="getIconType(getBaseItem)[1]")
        span.text-info(@click="openDocument(getBaseItem)") {{ getFileName(getBaseItem, true) }}
        font-awesome-icon.icon-item-arrow(v-if="!closed && versions.length > 1" icon="fas fa-angle-right" @click="toggleList")
        font-awesome-icon.icon-item-arrow(v-if="closed && versions.length > 1" icon="fas fa-angle-down" @click="toggleList")

    transition(name="dropdown")
        .list(v-if="closed")
            .file-item(v-for="item in getList" :key="item.id")
                font-awesome-icon.icon-item(:icon="getIconType(item)[0]" :class="getIconType(item)[1]")
                span.text-info(@click="openDocument(item)") {{ getFileName(item) }}
</template>

<script>
import get from 'lodash/get';
import GetGlobalSource from '@/libs/mixins/GetGlobalSource';
import {iconClasses} from './util';

export default {
  name: 'FileVersionList',
  mixins: [GetGlobalSource],
  data() {
    return {
      closed: false,
    };
  },
  props: {
    versions: {
      type: Array,
      required: true,
    },
  },
  computed: {
    getBaseItem() {
      //get item with the largest id
      const baseItem = this.versions.reduce((prev, current) => {
        return prev.id > current.id ? prev : current;
      });
      return baseItem;
    },
    getList() {
      //remove the base item
      return this.versions.filter(item => item.id !== this.getBaseItem.id);
    },
  },
  methods: {
    toggleList() {
      this.closed = !this.closed;
    },
    getIconType(item) {
      const object_type = get(item, 'file.payload.mime', '');
      return iconClasses(object_type);
    },
    getFileName(item, base = false) {
      return `${get(item, 'file.payload.name', '')} - Version ${get(item, 'label', '')} ${base ? '(Current)' : ''}`;
    },
    async openDocument(item) {
      const url = await this.getFileUrl(get(item, 'file.payload'));
      if (url) {
        window.open(url, '_blank');
      }
    },

  },
};
</script>

<style lang="scss" scoped>
@import "./icon.scss";
.file-item {
    padding-top: 10px;
    padding-bottom: 10px;
}

.list {
    padding-left: 30px;
}
.icon-item {
    margin-right: 10px;
}
.text-info {
    font-size: 16px;
    cursor: pointer;
    &:hover {
      color: #4671B3;
      text-decoration: underline;
      font-weight: bold;
    }
}
.icon-item-arrow {
    cursor: pointer;
    margin-left: 10px;
    font-size: 20px;
}

.dropdown-enter-active,
.dropdown-leave-active {
  transition: all 0.6s ease;
  overflow: hidden;
}

.dropdown-enter-from,
.dropdown-leave-to {
  opacity: 0;
  transform: translateY(-10px);
  max-height: 0;
}

.dropdown-enter-to,
.dropdown-leave-from {
  opacity: 1;
  transform: translateY(0);
  max-height: 500px;
}
</style>